import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Box } from "@memorang/ui";
import type { ComponentProps } from "react";
import { type StyleProp, StyleSheet, type ViewStyle } from "react-native";

type Props = {
	icon: ComponentProps<typeof Icon>["name"];
	background: string;
	color: string;
	size?: number;
	iconSize?: number;
	style?: StyleProp<ViewStyle>;
};

export const IconAvatar = ({
	icon,
	background,
	color,
	size = 40,
	iconSize = 20,
	style,
}: Props) => (
	<Box
		width={size}
		height={size}
		borderRadius={size / 2}
		alignItems="center"
		justifyContent="center"
		style={StyleSheet.flatten([{ backgroundColor: background }, style])}
	>
		<Icon name={icon} size={iconSize} color={color} />
	</Box>
);
